import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, finalize, tap } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
// import { LoaderService } from './../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private totalRequests = 0;

  constructor(private spinner: NgxSpinnerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // this.loaderService.show()
    if (this.totalRequests === 0) {
      this.spinner.show();
    }

    this.totalRequests++;

    // Excluir ciertas peticiones del spinner
    // if (!req.url.includes('/auth/refresh')) {
    //   this.spinner.show();
    // }

    return next.handle(req).pipe(
      tap({
        next: () => { 
          this.spinner.show();
        }, // Mantiene el loader si la respuesta aún está en curso
        error: () => {
          this.spinner.hide();
        }, // Si hay un error, oculta el loader
      }),
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests === 0) {
          this.spinner.hide();
        }
      }) // ✅ Solo oculta cuando la petición termina
    );
  }
}
